// W-0525 — CRUD de Cidades (isolado conforme ADR-010)
// W-0587 — estendido com parâmetro `ordem` em listarCidades + listarRegioes
import { httpService } from '~/Services/Service';

export const listarCidades = (filtros) => {
  const { q, estado, codigoRegiao, page, pageSize, ordenarPor, ordem } = filtros || {};
  const params = {};
  if (q) params.q = q;
  if (estado) params.estado = estado;
  if (codigoRegiao) params.codigoRegiao = codigoRegiao;
  if (page) params.page = page;
  if (pageSize) params.pageSize = pageSize;
  if (ordenarPor) params.ordenarPor = ordenarPor;
  if (ordem) params.ordem = ordem;
  return httpService.get('/cidades', { params });
};

// W-0587 — lista regiões para o dropdown do relatório
export const listarRegioes = () => httpService.get('/opcao/regioes');

// W-0587 — endpoint dedicado ao relatório (MEMORY.md §Shared Decisions: rota /cidades/relatorio, não /cidades)
export const listarCidadesPorRegiao = ({ codigoRegiao, ordem } = {}) => {
  const params = {};
  if (codigoRegiao) params.codigoRegiao = codigoRegiao;
  if (ordem) params.ordem = ordem;
  return httpService.get('/cidades/relatorio', { params });
};

export const obterCidade = (id) => httpService.get(`/cidades/${id}`);

export const criarCidade = (dto) => httpService.post('/cidades', dto);

// ADR-011 (CLAUDE.md): IIS bloqueia PUT — usar POST com rota semântica
export const atualizarCidade = (id, dto) =>
  httpService.post(`/cidades/${id}/atualizar`, dto);

// ADR-011 (CLAUDE.md): IIS bloqueia DELETE — usar POST com rota semântica
export const excluirCidade = (id) =>
  httpService.post(`/cidades/${id}/excluir`, {});

export const listarRegioesAtendimento = () =>
  httpService.get('/opcao/regioes');

export const listarPaises = () =>
  httpService.get('/opcao/paises');
